import { NgModule } from '@angular/core';
import { UsersnapModule } from './usersnap/usersnap.module';
import { BolddeskModule } from './bolddesk/boldesk.module';

const modules = [UsersnapModule, BolddeskModule];

@NgModule({
  imports: [modules],
  exports: [modules]
})
export class IntegrationModule {}
